module.exports = __webpack_public_path__ + "img/titleTwo4.b14c7688.png";